import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { Typography, Grid, Divider } from '@material-ui/core';
import { InsertDriveFile, GetApp } from '@material-ui/icons';
import { Section, SmSpace, Button } from 'm2m.components';
import { ParticipanteResponse } from 'common/genericTypes';
import { participanteDocumentLongDescriptions } from 'common/genericDescriptions';
import { RootState } from 'store';

interface Props {
  participante: ParticipanteResponse;
}

const mapStateToProps = (state: RootState) => ({
  participanteApi: state.participanteApi,
});

export const Documentos: React.FC<Props & ReturnType<typeof mapStateToProps>> = (props) => {
  const dispatch = useDispatch();
  const { getDocumentDownloadUrl } = props.participanteApi;

  const getAttachmentLink = async (documentId: string, name: string) => {
    try {
      const result = await getDocumentDownloadUrl(dispatch, props.participante.id, documentId);

      if (result) {
        const link = document.createElement('a');
        link.href = result;
        link.target = '_blank';
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Section title={'Documentos'}>
      {props.participante.documentos.map((documento) => (
        <React.Fragment key={documento.id}>
          <SmSpace />
          <Grid container>
            <Grid item md={5}>
              <Typography variant="body1">
                {participanteDocumentLongDescriptions[documento.participanteDocumentType]}
              </Typography>
            </Grid>
            <Grid item md={3} style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ display: 'flex' }}>
                <InsertDriveFile style={{ marginRight: 20 }} />
                <Typography variant="body1" display="inline">
                  {documento.fileName} - {`${Math.round((documento.size / 1000000) * 100) / 100}MB`}
                </Typography>
              </div>
            </Grid>
            <Grid item md={2} style={{ display: 'flex', alignItems: 'center' }}>
              <Button
                style={{ height: 'fit-content' }}
                startIcon={<GetApp />}
                onClick={() => getAttachmentLink(documento.id, documento.fileName)}
                variant="text"
              >
                {'Download'}
              </Button>
            </Grid>
            {/* <Grid item md={2} style={{ display: 'flex', alignItems: 'center' }}>
            <Button style={{ height: 'fit-content' }} startIcon={<Delete />} variant="text">{'Excluir'}</Button>
          </Grid> */}
          </Grid>
          <SmSpace />
          <Divider />
        </React.Fragment>
      ))}
    </Section>
  );
};

export default connect(mapStateToProps)(Documentos);
